'use client';

import { useState } from 'react';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';

import Button from '../Button/Button';

interface ShowMoreProps {
  moreTitleText?: string;
  lessTitleText?: string;
  previewLength?: number;
  text: string;
}

export const ShowMore = ({
  text,
  moreTitleText = 'Show More',
  lessTitleText = 'Show Less',
  previewLength = 100,
}: ShowMoreProps) => {
  const [open, setOpen] = useState(false);

  const words = text.split(' ');
  const willShowToggles = words.length > previewLength;
  const previewText = `${words.slice(0, previewLength).join(' ')}…`;

  return (
    <Stack
      component='p'
      sx={{
        m: 0,
        gap: sp[16],
        typography: 'bodyMd',
        color: '#000000',
      }}
    >
      {open || !willShowToggles ? text : previewText}
      {willShowToggles && (
        <Button
          variant='link'
          onClick={() => setOpen(!open)}
          ariaLabel={open ? lessTitleText : moreTitleText}
          iconRight={open ? 'chevron-up' : 'chevron-down'}
        >
          {open ? lessTitleText : moreTitleText}
        </Button>
      )}
    </Stack>
  );
};

export default ShowMore;
